import { render, staticRenderFns } from "./IntegrationSummary.vue?vue&type=template&id=958d2d4a&scoped=true&"
import script from "./IntegrationSummary.vue?vue&type=script&lang=ts&"
export * from "./IntegrationSummary.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationSummary.vue?vue&type=style&index=0&id=958d2d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958d2d4a",
  null
  
)

export default component.exports